/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'clsx';
import camelCase from 'lodash/camelCase';
import sidekick from '@last-rev/contentful-sidekick-util';
import styles from './VideoCard.module.scss';
import Asset from '../../Asset';
import AssetPropTypes from '../../Asset/AssetPropTypes';
import ElementLink from '../../ElementLink';
import ImageExpand from '../../ImageExpand';
import RichTextParserPropTypes from '../../RichTextParser/RichTextParserPropTypes';
import RichTextParser from '../../RichTextParser/RichTextParser';

export const VideoCardPropTypes = {
  _id: PropTypes.string,
  slug: PropTypes.string,
  headerText: PropTypes.string,
  summaryRichText: PropTypes.shape(RichTextParserPropTypes),
  image: PropTypes.shape(AssetPropTypes),
  imageExpand: PropTypes.bool,
  className: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  subjects: PropTypes.string,
  tagFilter: PropTypes.func,
  wistiaData: PropTypes.object
};

const VideoCard = ({
  _id=null,
  headerText=null,
  summaryRichText=null,
  image=null,
  imageExpand=false,
  className=null,
  tags=null,
  subjects=null,
  slug=null,
  tagFilter=null,
  wistiaData={},
  summaryText,
  router,
  onClick,
  parent
}) => {
  // NOTE: Contentful change, label only not prop name
  // Tags changed to Subcategories and Subjects changed to Categories
  const tagClasses = tags?.map((category) => `subcategory-${camelCase(category)}`);
  const subjectClass = `category-${camelCase(subjects)}`;

  const isSvg = image && image.url.includes('.svg');

  return (
    <div data-testid={`VideoCard-${_id}`} className={cx(styles.cardWrap, tagClasses, subjectClass, 'videoCard')} onClick={onClick}>
      <ElementLink href={slug} as={slug} test={router} isModal={false} download={false} linkText="" trackingId={`video_card_${slug}`}>
        <div className={cx(styles.card, [className])}>
          <div className={cx(styles.thumbWrap, isSvg && styles.isSvg)}>
            {image ? <Asset {...image} _id={_id} imageWrapClassName={styles.imageWrap} /> : null}
            {imageExpand && image ? <ImageExpand image={image} _id={_id} /> : null}
          </div>

          {tags ? (
            <div {...sidekick(_id, 'tags', null, 'Categories')} className={styles.tags} data-testid="VideoCard-categories">
              {tags.map((category) => (
                <span
                  key={camelCase(category)}
                  href={`?subcategory=${camelCase(category)}`}
                  as={`?subcategory=${camelCase(category)}`}
                  role="button"
                  tabIndex="-1"
                  data-testid={`VideoCard-tag-${category}`}
                  className={styles.category}>
                  {category}
                </span>
              ))}
            </div>
          ) : null}

          {headerText || summaryRichText || !!wistiaData?.name || !!wistiaData?.description ? (
            <div data-testid="VideoCard-TextWrap" className={parent?styles.homepagecraedBody:styles.cardBody}>
              {headerText || !!wistiaData?.name ? (
                <div className={styles.cardTitleWrap} {...sidekick(_id, 'headerText', null, 'Header Text')}>
                  <h3 data-testid="VideoCard-headerText" className={styles.cardTitle}>
                    {headerText ?? wistiaData?.name}
                  </h3>
                </div>
              ) : null}

              {summaryRichText || !!wistiaData?.description ? (
                <div className={styles.cardTextWrap} {...sidekick(_id, 'summaryRichText', null, 'Summary Rich Text')}>
                  <div data-testid="VideoCard-summaryRichText" className={styles.cardText}>
                    {summaryRichText ? (
                      <RichTextParser document={summaryRichText} />
                    ) : (
                      // eslint-disable-next-line react/no-danger
                      <div dangerouslySetInnerHTML={{ __html: wistiaData?.description.substring(0, 200) }} />
                    )}
                  </div>
                </div>
              ) : null}
              {summaryText ?
                <div className={styles.summaryText} {...sidekick(_id, 'summaryText', null, 'SummaryText')}>
                  <h3 data-testid="VideoCard-headerText" className={styles.cardSummary}>
                    {summaryText}
                  </h3>
                </div>
                : null}
              {/* {slug ? <span className={styles.cardCta}>Watch Now</span> : null} */}
            </div>
          ) : null}

        </div>
      </ElementLink>
    </div>
  );
};

VideoCard.propTypes = VideoCardPropTypes;


export default VideoCard;